/* eslint-disable */
require('./attack_enemies')
require('./attack_everyone')
require('./defend')
require('./fight_back')
require('./flee')
